import { Image } from '@acme/assets';
import './style.css';

export const Loading = ({
  className,
  text,
}: {
  className?: string;
  text?: string;
}) => {
  return (
    <div
      className={`flex w-full flex-col items-center gap-8 leading-[normal] ${className}`}
    >
      <Image name="spinner" width={120} height={120} className="animate-spin" />

      <div className="text-text-secondary font-inter self-stretch text-center leading-6">
        {text}
      </div>
    </div>
  );
};
